import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dataForm",
  style: {"min-width":"1000px"}
}
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_OrderFeeDesc = _resolveComponent("OrderFeeDesc")!
  const _component_AccountPreview = _resolveComponent("AccountPreview")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_ctx.detail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "form-title mb-10 mt-10" }, [
          _createElementVNode("span", { class: "label green" }, "业"),
          _createElementVNode("span", { class: "left" }, "业务基本信息")
        ], -1)),
        _createVNode(_component_el_descriptions, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "编号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.no), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "公司名称：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.customerCompany), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "名称：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "品牌：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.brand), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "数量：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.amount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "单位：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.unit), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "型号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.model), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "序列号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.serial), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.detail.business.orderTaxRate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "form-title mb-10" }, [
                _createElementVNode("span", { class: "label blue" }, "订"),
                _createElementVNode("span", { class: "left" }, "订单信息")
              ], -1)),
              _createVNode(_component_OrderFeeDesc, {
                detail: _ctx.detail.business
              }, {
                after: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "开票状态：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.detail.business.invoiceStatus), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "收款状态：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.detail.business.receivedStatus), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["detail"])
            ]))
          : _createCommentVNode("", true),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "form-title mb-10 mt-30" }, [
          _createElementVNode("span", { class: "label yellow" }, "审"),
          _createElementVNode("span", { class: "left" }, "审批信息")
        ], -1)),
        (_ctx.detail.account)
          ? (_openBlock(), _createBlock(_component_AccountPreview, {
              key: 1,
              account: _ctx.detail.account
            }, {
              content: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "费用：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$currency(_ctx.detail.fee)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "申请时间：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail.createTime), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "申请次数：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail.times), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["account"]))
          : _createCommentVNode("", true),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "form-title mb-10 mt-30" }, [
          _createElementVNode("span", { class: "label green" }, "其"),
          _createElementVNode("span", { class: "left" }, "其他市场费信息")
        ], -1)),
        _createVNode(_component_el_table, {
          data: _ctx.detail.history || [],
          border: "",
          fit: "",
          "row-key": "id",
          class: "fullWidth",
          "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MarketFeeFieldData, (column, index) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                prop: column.fieldKey,
                label: column.fieldName,
                key: index,
                "min-width": "120"
              }, _createSlots({ _: 2 }, [
                (column.fieldKey === 'fee')
                  ? {
                      name: "default",
                      fn: _withCtx(({ row }) => [
                        _createTextVNode(_toDisplayString(_ctx.$currency(row.fee)), 1)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["prop", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["data"])
      ]))
    : _createCommentVNode("", true)
}